// @ts-nocheck
import React, { useEffect, useReducer, useRef, ReactElement  } from "react";

// Interface for list item
interface ListItem {
	type: string;
	title: string;
	value: string;
	child: boolean;
	version: string;
	list?: ListItem[];
}

// Interface for suggested item
interface SuggestedItem {
	title: string;
	value: string;
	list?: SuggestedItem[];
}

// Interface for component state
interface ListSelectorState {
	selected: { [key: string]: boolean };
	list: ListItem[];
	type: string;
	expanded: { [key: string]: boolean };
}

// Interface for component props
interface ListSelectorProps {
	type?: string;
	iteration?: number;
	list?: ListItem[];
	suggested?: SuggestedItem[];
	onChange?: (list: ListItem[]) => void;
}

const ListSelectorReducer = function( state: ListSelectorState, [ type, data ]: [string, wts_ignore_any] ): ListSelectorState {

	if( type === "expanded" ){
		return {
			...state,
			expanded: { ...state.expanded,
				[data.key]: (
					data.list && data.list.length ? data.value : false
				)
			}
		};
	}else if( type === "list" ){

		let list = [ ...data ];
		let selected = {};

		for( let item of list ){
			selected[ item.value ] = true;
		};

		return {
			...state,
			selected: selected,
			list: list
		};
	}else if( type === "selected" ){

		let list = [ ...state.list ];
		let selected = { ...state.selected };

		let index = list.findIndex(( f ) => f.value === data.key );

		if( data.value && index < 0 ){
			list.push({
				type: (state.type || ""),
				title: (data.title || ""),
				value: (data.key || ""),
				child: !!data.child,
				version: ""
			});
			selected[ data.key ] = true;
		}else if( !data.value && index > -1 ){
			list.splice( index, 1 );
			delete selected[ data.key ];
		};

		return {
			...state,
			list: list,
			selected: selected
		};
	};

	return state;
};

const ListSelectorItem = function( item: SuggestedItem, state: ListSelectorState, dispatch: React.Dispatch<[string, wts_ignore_any]>, root?: boolean ): ReactElement {

	return (
		<div className={ "lselector-elem" + (state.selected[ item.value ] ? " lselector-elem-selected" : "") } key={ item.value }>
			<div className={ "lselector-elem-head" }>
				<svg className={ "lselector-elem-checkbox" }
					 viewBox="0 0 24 24"
					 onClick={() => {
						 dispatch([ "selected", { key: item.value, title: item.title, value: !state.selected[ item.value ], child: !root } ]);
					 }}
				>
					<path d="M6.445 12.668a.9.9 0 00-1.303
					1.242l3.573 3.745a.9.9 0 001.335-.036l8.591-10.037a.9.9
					0 00-1.367-1.17l-7.656 8.944a.4.4 0 01-.593.016l-2.58-2.704z"></path>
				</svg>
				<div className={ "lselector-elem-title lselector-parent-title" }
					 onClick={() => {
						 dispatch([ "expanded", { key: item.value, value: !state.expanded[ item.value ], list: item.list, child: !root } ]);
					 }}
				>{ item.title }</div>
			</div>
			<div className={ "lselector-elem-list" + (state.expanded[ item.value ] ? "" : " hidden") }>
				{
					(item.list || []).map(( item: SuggestedItem ) => {
						return ListSelectorItem( item, state, dispatch );
					})
				}
			</div>
		</div>
	);
};

export const ListSelector = ( props: ListSelectorProps ) => {

	const [ state, dispatch ] = useReducer( ListSelectorReducer, {
		selected: {},
		list: [],
		type: props.type || "",
		expanded: {}
	});

	useEffect(() => {
		dispatch([ "list",  props.list || [] ]);
	}, [ props.iteration ]);

	useEffect(() => {

		if( !props.onChange )
			return;

		props.onChange( state.list );

	}, [ state.selected ]);

	return (
	<div className={ "lselector" }>
		<div className={ "lselector-wrap" }>
		{
			(props.suggested || []).map(( item: SuggestedItem ) => {
				return ListSelectorItem( item, state, dispatch, true );
			})
		}
		</div>
	</div>
	);
};